<template>
    <section class="property-summary">
        <ul class="property-summary__segments">
            <summary-segment-item v-for="segment in this.$scheme.segmentKeymap"
                                  class="property-summary__segments__item"
                                  :key="segment.key"
                                  :segment="segment" />
        </ul>
    </section>
</template>

<script>

import SummarySegmentItem from './summary-segment-item'

export default {

    components: {
        SummarySegmentItem,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\my-home\_property-summary.scss

.property-summary {

    @include bp-min-wide {
        padding: rem(20px) rem(10px) 0 0;
    }

    @include element('text') {
        font-size: 0.9rem;

        @include bp-min-wide {
            font-size: 1rem;
        }
    }

    @include element('segments') {
        @include unstyle-list;
        margin-top: rem(10px);

        @include element('item') {
            margin-bottom: 1rem !important;

            &:last-child {
                margin-bottom: 0 !important;
            }

            @include bp-min-mid {
                margin-bottom: 0.5rem !important;
            }
        }
    }
}

</style>
